import {
  LayoutInfoType,
  LayoutState,
  SaveLayoutType,
  updateLayoutType,
} from '../types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: LayoutState = {
  layouts: [],
  layoutConfig: null,
}

const layoutSlice = createSlice({
  name: 'layouts',
  initialState: initialState,
  reducers: {
    updateLayout: (state, action: PayloadAction<updateLayoutType>) => {
      void action.payload
      return state
    },
    saveLayout: (state, action: PayloadAction<SaveLayoutType>) => {
      void action.payload
      return state
    },
    addLayoutConfig: (state, action: PayloadAction<LayoutInfoType>) => {
      state.layoutConfig = action?.payload
    },
    resetLayoutConfig: (state, action: PayloadAction<null>) => {
      void action?.payload
      state.layoutConfig = null
    },
  },
})

export const { updateLayout,saveLayout, addLayoutConfig, resetLayoutConfig } =
  layoutSlice.actions
export default layoutSlice.reducer
